/**
 * @generated SignedSource<<6bd05e2e2b9097d8dbf3e4020cd14185>>
 * @relayHash 61901cb86a068ab7b9df9bbc44f9c05a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4a0700bc188b20753c05c10b3c1ce40c8d6df7c1fbc9e0a04730a0473c5df0b5

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfileCardEntryPointQuery$variables = {
  cloudId: string;
  orgId: string;
  skipKnowledgeDiscovery: boolean;
  userAri: string;
  userId: string;
  userIdString: string;
  viewerId: string;
};
export type UserProfileCardEntryPointQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileCardRelay_query">;
};
export type UserProfileCardEntryPointQuery = {
  response: UserProfileCardEntryPointQuery$data;
  variables: UserProfileCardEntryPointQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipKnowledgeDiscovery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIdString"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewerId"
},
v7 = {
  "kind": "Variable",
  "name": "orgId",
  "variableName": "orgId"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "picture"
},
v11 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v13/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v13/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v13/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v13/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ]
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "url"
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v22 = [
  (v21/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v21/*: any*/),
      (v12/*: any*/)
    ]
  }
],
v23 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v24 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v25 = [
  (v19/*: any*/),
  (v12/*: any*/)
],
v26 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "skipKnowledgeDiscovery",
            "variableName": "skipKnowledgeDiscovery"
          },
          {
            "kind": "Variable",
            "name": "userAri",
            "variableName": "userAri"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          },
          {
            "kind": "Variable",
            "name": "userIdString",
            "variableName": "userIdString"
          },
          {
            "kind": "Variable",
            "name": "viewerId",
            "variableName": "viewerId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "UserProfileCardRelay_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
          }
        ],
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "accountStatus"
          },
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "email"
              },
              {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "department"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "location"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "organization"
                  }
                ]
              }
            ],
            "type": "AtlassianAccountUser"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appType"
              }
            ],
            "type": "AppUser"
          },
          (v12/*: any*/)
        ]
      },
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "fields": [
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "actors.0",
                        "variableName": "userAri"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "actors"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 50
              }
            ],
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceDatabaseLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v13/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceDatabase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceEmbedLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v13/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceEmbed"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v18/*: any*/),
                                "type": "ConfluenceFooterComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v18/*: any*/),
                                "type": "ConfluenceInlineComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "TownsquareGoal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "TownsquareProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "TownsquareComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v21/*: any*/)
                                ],
                                "type": "JiraIssue"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "JiraPlatformComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "JiraServiceManagementComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "TrelloBoard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v23/*: any*/),
                                "type": "TrelloCard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v24/*: any*/),
                                "type": "DevOpsDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "DevOpsPullRequestDetails"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v24/*: any*/),
                                "type": "DevOpsDesign"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "ExternalRemoteLink"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "MercuryFocusArea"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "MercuryPortfolio"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "RadarPosition"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "RadarView"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "CompassComponent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "href"
                                  }
                                ],
                                "type": "BitbucketPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "loomUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "LoomVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "AssetsObject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "AssetsObjectType"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "AssetsSchema"
                              },
                              (v17/*: any*/)
                            ]
                          },
                          (v12/*: any*/)
                        ]
                      },
                      (v12/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skipKnowledgeDiscovery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "userIdString"
                  },
                  (v7/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "requestingUserId",
                    "variableName": "viewerId"
                  },
                  {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "LinkedField",
                "name": "singleUser",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeDiscoveryUserProfile",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "KnowledgeDiscoveryUserManager",
                            "kind": "LinkedField",
                            "name": "manager",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v11/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                            "kind": "LinkedField",
                            "name": "thirdPartyIntegrations",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "externalId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "integrationId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "product"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeDiscoverySingleUser"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4a0700bc188b20753c05c10b3c1ce40c8d6df7c1fbc9e0a04730a0473c5df0b5",
    "metadata": {},
    "name": "UserProfileCardEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bd465fb67955379e19bc4ffef9145f96";

export default node;
